import { api } from "../index";

export const organizationSubscriptionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    adminGetSubscription: builder.query({
      query: () => "/api/v1/organization/subscription",
      providesTags: ["Subscription"],
    }),
    adminUpdateSubscription: builder.mutation({
      query: (body) => ({
        url: "/api/v1/organization/subscription",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Subscription"],
    }),
    adminCancelSubscription: builder.mutation({
      query: () => ({
        url: "/api/v1/organization/subscription/cancel",
        method: "POST",
      }),
      invalidatesTags: ["Subscription"],
    }),
    adminReactivateSubscription: builder.mutation({
      query: () => ({
        url: "/api/v1/organization/subscription/reactivate",
        method: "POST",
      }),
      invalidatesTags: ["Subscription"],
    }),
    adminGetTransactions: builder.query({
      query: (params) => ({
        url: "/api/v1/organization/transactions",
        params,
      }),
      providesTags: ["Transactions"],
    }),
    adminRetryPayment: builder.mutation({
      query: (body) => ({
        url: "/api/v1/organization/subscription/retry_payment",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Subscription", "PaymentMethods"],
    }),
    adminGetPaymentMethods: builder.query({
      query: () => "/api/v1/organization/payment_methods",
      providesTags: ["PaymentMethods"],
    }),
    adminAddPaymentMethod: builder.mutation({
      query: (body) => ({
        url: "/api/v1/organization/payment_methods/add_card",
        method: "POST",
        body,
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
    adminDeletePaymentMethod: builder.mutation({
      query: (id) => ({
        url: `/api/v1/organization/payment_methods/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
    adminGetPaymentMethod: builder.query({
      query: (id) => `/api/v1/organization/payment_methods/${id}`,
      providesTags: (result, error, id) => [{ type: "PaymentMethods", id }],
    }),
    adminSetDefaultPaymentMethod: builder.mutation({
      query: (id) => ({
        url: `/api/v1/organization/payment_methods/${id}/set_default`,
        method: "POST",
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
    adminGetPaymentStatus: builder.query({
      query: (params) => {
        const { subscriptionId, transactionId } = params || {};
        const urlParams = [];
        if (transactionId) urlParams.push(`transaction_id=${transactionId}`);
        if (subscriptionId) urlParams.push(`subscription_id=${subscriptionId}`);
        
        const base = "/api/v1/organization/subscription/payment_status";
        return urlParams.length > 0 ? `${base}?${urlParams.join("&")}` : base;
      },
    }),
    adminRenewSubscription: builder.mutation({
      query: (body) => ({
        url: "/api/v1/organization/subscription/renew",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Subscription", "PaymentMethods"],
    }),
  }),
});

export const {
  useAdminGetSubscriptionQuery,
  useAdminUpdateSubscriptionMutation,
  useAdminCancelSubscriptionMutation,
  useAdminReactivateSubscriptionMutation,
  useAdminGetTransactionsQuery,
  useAdminRetryPaymentMutation,
  useAdminGetPaymentMethodsQuery,
  useAdminDeletePaymentMethodMutation,
  useAdminAddPaymentMethodMutation,
  useAdminGetPaymentMethodQuery,
  useAdminSetDefaultPaymentMethodMutation,
  useAdminGetPaymentStatusQuery,
  useAdminRenewSubscriptionMutation,
} = organizationSubscriptionApi;
